import React from "react";
import CompletedShipment from "./CompletedShipment";

const BilledShipments = ({
  role = "employee",
  filterValue = "Owned",
  onRowClick,
  selectedYear = "all",
  selectedMonth = "all",
  selectedShipmentType = "all",
}) => {
  return (
    <CompletedShipment
      role={role}
      filterValue={filterValue}
      isBilledOnly={true}
      onRowClick={onRowClick}
      selectedYear={selectedYear}
      selectedMonth={selectedMonth}
      selectedShipmentType={selectedShipmentType}
    />
  );
};

export default BilledShipments;
